import { render } from "./GeneralDonate.vue?vue&type=template&id=dd49c9a2&scoped=true"
import script from "./GeneralDonate.vue?vue&type=script&lang=js"
export * from "./GeneralDonate.vue?vue&type=script&lang=js"

import "./GeneralDonate.vue?vue&type=style&index=0&id=dd49c9a2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dd49c9a2"

export default script